export enum MoveRecordDirection {
  Up = 'up',
  Down = 'down',
}
